module.exports = {
  enrollData: {
    dataUrl: "/api/enroll/data"
  },
  //机构
  org: {
    // /api/uni/find
    searchUrl: "/api/uni/find"
  },

  //电子简章
  ebook: {
    viewUrl: "/api/book/find",
    listUrl: "/api/book/find",
    listByOg: "/api/uni/find",
    infoUrl: "/api/book/get",
    addUrl: "/api/ebook/add",
    editUrl: "/api/ebook/edit",
    delUrl: "/api/ebook/del",
    searchUrl: "/api/ebook/search",
    listSeriesUrl: "/api/book/find",
    subscribeUrl: "/api/book/sub",
    zhuan: {
      // listUrl: "/api/collect/list",
      // infoUrl: "/api/ebook/info",
      addUrl: "/api/ebook/addSet",
      editUrl: "/api/ebook/editSet",
      delUrl: "/api/ebook/delSet",
      searchUrl: "/api/ebook/searchSet",
      // searchByStartTimeUrl: "/api/collect/searchByStartTime",
      toggleUrl: "/api/ebook/toggleSet",
      listPdf: "/api/book/find",
      attachUrl: "/api/ebook/attachToSet"
    }
  },
  // 活动接口
  // activity: {
  //   listUrl: "/api/activity/list",
  //   deleteUrl: "/api/activity/del",
  //   addUrl: "/api/activity/add",
  //   updateUrl: "/api/activity/edit",
  //   //活动报名和签到人员接口
  //   people: {
  //     listUrl: "/api/activity/listEnroll",
  //     exportEnrollListUrl: "/api/activity/exportEnrollList"
  //   },
  //   //活动问题提问相关接口
  //   question: {
  //     listUrl: "/api/activity/listQuestion",
  //     exportListUrl: "/api/activity/exportQuestionList"
  //   },
  //   //图表
  //   echart: {
  //     listUrl: "/api/activity/stat"
  //   }
  // },
  // // 机构学校接口
  // org: {
  //   listUrl: "/api-gkb/org/getlist"
  // },

  // //电子简章
  // ebook: {
  //   listUrl: "/api/ebook/list",
  //   infoUrl: "/api/ebook/info",
  //   addUrl: "/api/ebook/add",
  //   editUrl: "/api/ebook/edit",
  //   delUrl: "/api/ebook/del",
  //   searchUrl: "/api/ebook/search"
  // },

  //专场

  zhuan: {
    listUrl: "/api/collect/list",
    // infoUrl: "/api/ebook/info",
    addUrl: "/api/collect/add",
    editUrl: "/api/collect/edit",
    // delUrl: "/api/collect/del",
    searchUrl: "/api/collect/search",
    searchByStartTimeUrl: "/api/collect/searchByStartTime",
    toggleUrl: "/api/collect/toggleCollect",

    table: {
      schoolStatUrl: "/api/collect/schoolStat",
      chatStatUrl: "/api/collect/chatStat",
      subscribeStatUrl: "/api/collect/subscribeStat",
      briefStatUrl: "/api/collect/briefStat",
      browserUrl: "/api/collect/browseStat",
      userStatUrl: "/api/collect/userStat"
    },
    download: {
      allurl: "/api/collect/exportData"
    },

    // 宣讲列表
    video: {
      listUrl: "/api/collect/listStreams",
      similarUrl: "/api/collect/similarList?limit=4&page=1&status=1"
    },

    // 专场大类
    cateGory: {
      listUrl: "/api/collect/listCategory",
      addUrl: "/api/collect/addCategory",
      editUrl: "/api/collect/editCategory",
      delUrl: "/api/collect/delCategory",
      toggleUrl: "/api/collect/toggleCategory"
    },

    //高中库模板

    school: {
      uploadUrl: "/api/collect/uploadPushSchool",
      downloadUrl: "/api/collect/downloadPushSchool",
      listUrl: "/api/collect/listPushTemplate",
      addUrl: "/api/collect/addPushTemplate",
      editUrl: "/api/collect/editPushTemplate",
      delUrl: "/api/collect/delPushTemplate",
      viewList: "/api/collect/listPushSchool",
      removeSchool: "/api/collect/removePushSchool"
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/api.js